import {
  BookOutlined,
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  RedoOutlined,
} from '@ant-design/icons';
import { Popconfirm } from 'antd';
import React from 'react';
export const PopOverContent = (props: any) => {
  const { role, onSetTitle, onSetVisibleDrawer, rowData, onSetRow } = props;

  React.useEffect(() => {
    onSetRow(rowData);
  }, []);
  return (
    <div>
      <div>
        <EyeOutlined style={{ marginRight: 15 }} />
        View
      </div>
      <hr />
      <div>
        <EditOutlined style={{ marginRight: 15 }} />
        Update
      </div>
      <hr />
      {role === 'Student' && (
        <div>
          <div>
            <BookOutlined style={{ marginRight: 15 }} />
            <a
              onClick={() => {
                onSetTitle('Issue Book');
                onSetVisibleDrawer(true);
              }}
            >
              Issue Book
            </a>
          </div>

          <hr />
          <div>
            <BookOutlined style={{ marginRight: 15 }} />
            <a
              onClick={() => {
                onSetTitle('View Issued Books');
                onSetVisibleDrawer(true);
              }}
            >
              View Issued Books
            </a>
          </div>
          <hr />
          <div>
            <BookOutlined style={{ marginRight: 15 }} />
            <a
              onClick={() => {
                onSetTitle('Assign Parent');
                onSetVisibleDrawer(true);
              }}
            >
              Assign Parent
            </a>
          </div>
          <hr />
          <div>
            <BookOutlined style={{ marginRight: 15 }} />
            <a
              onClick={() => {
                onSetTitle('Alert Notice');
                onSetVisibleDrawer(true);
              }}
            >
              Alert Notice
            </a>
          </div>
          <hr />
        </div>
      )}
      {(role === 'Teacher' || role === 'Student') && (
        <div>
          <div>
            <BookOutlined style={{ marginRight: 15 }} />
            <a
              onClick={() => {
                onSetTitle('Load Amount');
                onSetVisibleDrawer(true);
              }}
            >
              Load Amount
            </a>
          </div>
          <hr />
          <div>
            <BookOutlined style={{ marginRight: 15 }} />
            <a
              onClick={() => {
                onSetTitle('View Transactions');
                onSetVisibleDrawer(true);
              }}
            >
              View Transactions
            </a>
          </div>
          <hr />
          <div>
            <BookOutlined style={{ marginRight: 15 }} />
            <a
              onClick={() => {
                onSetTitle('Assign Card');
                onSetVisibleDrawer(true);
              }}
            >
              Assign Card
            </a>
          </div>
          <hr />
        </div>
      )}
      <div>
        <DeleteOutlined style={{ marginRight: 15 }} />
        <Popconfirm
          title="Are you sure to delete this data?"
          //   onConfirm={confirm}
          //   onCancel={cancel}
          okText="Yes"
          cancelText="Cancel"
        >
          <a href="#">Delete</a>
        </Popconfirm>
      </div>
      <hr />
      <div>
        <RedoOutlined style={{ marginRight: 10 }} />
        Reset Password
      </div>
    </div>
  );
};
